var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_186_8254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 5.33398V8.00065L9.33333 9.33398",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.03345 7.33338C2.18284 5.86675 2.86696 4.50645 3.95527 3.51202C5.04358 2.51759 6.45991 1.95864 7.93403 1.9418C9.40815 1.92496 10.8369 2.45142 11.9476 3.42073C13.0584 4.39005 13.7734 5.73436 13.9562 7.1972C14.1391 8.66003 13.777 10.139 12.939 11.3519C12.1011 12.5648 10.8459 13.4267 9.41297 13.7733C7.98006 14.1198 6.46972 13.9267 5.17011 13.2308C3.8705 12.5348 2.87259 11.3848 2.36678 10M2.03345 13.3334V10H5.36678",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_186_8254"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refresh-icon.850d4f66feda83da767ce8bada28bd14.svg";
export { ForwardRef as ReactComponent };